import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import {handleError} from "../../../helpers/handleError";
import eventBus from "../../../event-bus/eventBus";

const updateProduct = {
    namespaced: true,
    state: {
        updateProductIsFetching: false,
    },
    mutations: {
        SUCCESS_UPDATE_PRODUCT(state, response) {
            eventBus.$emit('updateVisibleProductResponseModal', response.data.message, response.data.data.textInfo);
            eventBus.$emit('saveProductSuccess');
        },
        FAILURE_UPDATE_PRODUCT(state, error) {
            eventBus.$emit('updateVisibleProductResponseModal', error.response.data.message, handleError(error) !== "" ? handleError(error) : error.response.data.data.message);
            eventBus.$emit("saveProductFailure", error.response.data.errors);
        },
        DATA_UPDATE_REQUEST(state, value) {
            state.updateProductIsFetching = value;
        },
    },
    actions: {
        updateProductRequest({ dispatch }, payload) {
            dispatch("requestDataUpdate", true);
            var promise = sendRequest("put", config.baseURLApi + "/products/" + payload.id, {}, payload)
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("updateProductSuccess", result[1]);
                } else {
                    dispatch("updateProductFailure", result[1]);
                }
                dispatch("requestDataUpdate", false);
            });
        },
        updateProductSuccess({ commit }, response) {
            commit("SUCCESS_UPDATE_PRODUCT", response);
        },
        updateProductFailure({ commit }, error) {
            commit("FAILURE_UPDATE_PRODUCT", error);
        },
        requestDataUpdate({ commit }, value) {
            commit("DATA_UPDATE_REQUEST", value);
        },
    }
}

export default updateProduct;